module.exports = __webpack_public_path__ + "02_long_grey.dfe265c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_long_grey.png
// module id = Qj48
// module chunks = 0